import script from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"

import "./manage-profile.vue?vue&type=style&index=0&id=dc3833d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc3833d0"]])

export default __exports__